import React from "react";
// Scss
import "./projectBox.scss";
import ArIcon from "../../../assets/portfolio/ar-icon.png";

const projectBox = (props) => (
  <div className="portfolio__box">
    <img src={props.preview} alt="project" />
    {props.modelType === "ar" ?
      <div className="team__box-info" style={{display:"flex", flexDirection:"row", justifyContent:"space-between", alignItems:"center"}}>
        <p className="font15 weight800">AR </p>
        <img src={ArIcon} style={{ height:"20px", width:"auto" }} alt="ar-icon" />
      </div> : null}
    <div className="portfolio__hover-info flex-center">
      <div className="text-center">
        <p className="font30 weight800">{props.title}</p>
        <p className="font12 weight500">{props.tag}</p>
      </div>
    </div>
  </div>
);

export default projectBox;
